module.exports = __webpack_public_path__ + "img/KY.f223d8f1.png";